'use strict';

export default function Loading({ active, absolute = true, text = null, styleContainer = {}, style = {} }) {
    if (!active) 
        return null;

    const className = text !== null || absolute === false ? 'preloader' : 'loaderContainer';
    return <div className={className} style={styleContainer}>
        <div className="loader" style={style}></div>
        {text !== null && <span className="loader-text">
            {text}
        </span>}
    </div>
}
